import { ApplicationConfig, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';
import { catchError } from 'rxjs';
import { Router } from '@angular/router';
import { routes } from './app.routes';
import { AuthService } from './core/auth.service';

const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const token = auth.token;
  const request = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(request).pipe(
    catchError((error) => {
      if (error.status === 401) {
        auth.logout();
        router.navigateByUrl('/login');
      }
      throw error;
    })
  );
};

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideHttpClient(withInterceptors([authInterceptor]))]
};
